// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"DashBoardHeader__materialize-textarea___1maV-","modal-2463794813":"DashBoardHeader__modal-2463794813___3-Ptu","container":"DashBoardHeader__container___3n3r9","coachContainer":"DashBoardHeader__coachContainer___3Kevo","urlPath":"DashBoardHeader__urlPath___2h1ub","currentUrl":"DashBoardHeader__currentUrl___ufL05"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DashBoardHeader/DashBoardHeader.scss
// module id = 1483
// module chunks = 0